import './PrivacyPolicy.css'

export function PrivacyPolicy() {
  return (
    <div className="privacy-policy">
      <div className="privacy-content">
        <h1>Privacy Policy</h1>

        <p className="last-updated">Last updated: {new Date().toLocaleDateString()}</p>

        <section>
          <h2>Introduction</h2>
          <p>
            MonotonicID Decoder is a utility tool that helps you decode and analyze
            timestamp-based monotonic identifiers. We respect your privacy and are
            committed to protecting your personal data.
          </p>
        </section>

        <section>
          <h2>Data We Collect</h2>
          <p>
            This website operates entirely in your browser. The identifiers you decode
            are processed locally and are not sent to any server.
          </p>

          <h3>Analytics (Optional)</h3>
          <p>
            With your explicit consent, we use Google Analytics to understand how
            visitors use our site. This helps us improve the user experience.
            We collect:
          </p>
          <ul>
            <li>Pages visited and features used</li>
            <li>Time spent on the site</li>
            <li>Browser type and device information</li>
            <li>Anonymous IP addresses (IP anonymization enabled)</li>
          </ul>
          <p>
            <strong>We do NOT collect:</strong>
          </p>
          <ul>
            <li>The actual identifiers you decode</li>
            <li>Any personally identifiable information</li>
            <li>Any data entered into the decoder</li>
          </ul>
        </section>

        <section>
          <h2>Cookies</h2>
          <p>
            We use localStorage (not cookies) to remember your consent preference.
            If you accept analytics, Google Analytics may set cookies to track your
            session. You can learn more about Google Analytics cookies in their{' '}
            <a
              href="https://policies.google.com/technologies/cookies"
              target="_blank"
              rel="noopener noreferrer"
            >
              cookie policy
            </a>.
          </p>
        </section>

        <section>
          <h2>Your Rights</h2>
          <p>Under GDPR and CCPA, you have the right to:</p>
          <ul>
            <li><strong>Withdraw consent:</strong> Change your analytics preferences at any time</li>
            <li><strong>Access your data:</strong> Request information about data we collect</li>
            <li><strong>Delete your data:</strong> Request deletion of any collected data</li>
            <li><strong>Opt out:</strong> Decline or disable analytics tracking</li>
          </ul>
        </section>

        <section>
          <h2>Third-Party Services</h2>
          <p>
            We use Google Analytics (with your consent). Please review Google's
            privacy policy:
          </p>
          <ul>
            <li>
              <a
                href="https://policies.google.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Google Privacy Policy
              </a>
            </li>
            <li>
              <a
                href="https://support.google.com/analytics/answer/6004245"
                target="_blank"
                rel="noopener noreferrer"
              >
                Google Analytics Data Privacy
              </a>
            </li>
          </ul>
        </section>

        <section>
          <h2>Data Security</h2>
          <p>
            Since all processing happens in your browser and we don't collect the
            identifiers you decode, your data remains private and secure on your device.
          </p>
        </section>

        <section>
          <h2>Children's Privacy</h2>
          <p>
            This service is not directed at children under 13. We do not knowingly
            collect data from children.
          </p>
        </section>

        <section>
          <h2>Changes to This Policy</h2>
          <p>
            We may update this privacy policy from time to time. Any changes will be
            posted on this page with an updated revision date.
          </p>
        </section>

        <section>
          <h2>Contact</h2>
          <p>
            If you have questions about this privacy policy or wish to exercise your
            rights, please contact us through our{' '}
            <a
              href="https://github.com/denormans/monotonicid"
              target="_blank"
              rel="noopener noreferrer"
            >
              GitHub repository
            </a>.
          </p>
        </section>
      </div>
    </div>
  )
}
